export default __webpack_public_path__ + "static/app-store-badge-ru-2ac2876e9ce7751235fabcfdb4d2dda0.svg";